import type {
  InvoicePreview,
  InvoicePreviewError,
} from '@portal/types/nexudus';

/**
 * Validate an invoice preview after applying a discount code.
 * Returns an error message if the code was rejected or not applied,
 * or `null` if the discount was successfully applied.
 */
export function validateDiscountResult(
  invoice: (InvoicePreview & Partial<InvoicePreviewError>) | null,
  code: string,
): string | null {
  if (!invoice) return null;

  if (invoice.Message) {
    return 'Invalid discount code';
  }

  const applied = invoice.Lines?.some(
    (line) =>
      line.DiscountCode &&
      line.DiscountCode.toLowerCase() === code.toLowerCase(),
  );

  if (!applied) {
    return 'This discount code does not apply to items being purchased';
  }

  return null;
}
